/**
 * Updates variant-level custom properties when variant changes
 */
if (!customElements.get('variant-properties')) {
  class VariantProperties extends HTMLElement {
    constructor() {
      super();
      this.propertyFields = [
        '_is_freight',
        '_freight_class',
        '_length',
        '_width',
        '_height',
        '_actual_weight'
      ];
      this.initialized = false;
    }

    connectedCallback() {
      setTimeout(() => {
        if (!this.initialized) {
          this.productForm = this.closest('form') || this.closest('.js-product-form-main') || this.closest('.js-product-form');
          
          if (this.productForm) {
            this.init();
            this.initialized = true;
          }
        }
      }, 100);
    }

    init() {     
      this.propertyContainer = this.productForm.querySelector('input[name="id"]')?.parentNode;
      if (!this.propertyContainer) return;
      
      const variantIdInput = this.productForm.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.addEventListener('change', this.handleVariantIdChange.bind(this));
        
        if (variantIdInput.value) {
          const variantData = this.getVariantData(parseInt(variantIdInput.value));
          if (variantData) {
            this.updatePropertyInputs(variantData);
          }
        }
      }
      
      const productSection = this.closest('.js-product');
      const variantPicker = productSection ? productSection.querySelector('variant-picker') : document.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    /**
     * Handles changes to the variant ID input
     * @param {Event} evt - Change event
     */
    handleVariantIdChange(evt) {
      const variantId = parseInt(evt.target.value);
      if (!variantId) return;
      
      const variantData = this.getVariantData(variantId);
      this.updatePropertyInputs(variantData || {});
    }

    /**
     * Handles variant change events
     * @param {CustomEvent} evt - Variant change event
     */
    handleVariantChange(evt) {
      const { variant } = evt.detail;
      if (!variant) return;
      
      const variantData = this.getVariantData(variant.id);
      this.updatePropertyInputs(variantData || {});
    }

    /**
     * Gets variant metafield data from the data element
     * @param {number} variantId - Variant ID
     * @returns {object|null} Variant metafield data
     */
    getVariantData(variantId) {
      const dataEl = this.querySelector(`[data-variant-id="${variantId}"]`);
      if (!dataEl) return null;

      try {
        return JSON.parse(dataEl.textContent);
      } catch (e) {
        return null;
      }
    }

    /**
     * Updates property input values
     * @param {object} variantData - Variant metafield data
     */
    updatePropertyInputs(variantData) {     
      this.propertyFields.forEach((propertyName) => {
        const metafieldKey = propertyName.replace(/^_/, '');
        const existingInput = this.productForm.querySelector(`input[name="properties[${propertyName}]"]`);

        if (variantData[metafieldKey] !== undefined && variantData[metafieldKey] !== null && variantData[metafieldKey] !== '') {         
          if (existingInput) {           
            existingInput.value = variantData[metafieldKey];
          } else {           
            const newInput = document.createElement('input');
            newInput.type = 'hidden';
            newInput.name = `properties[${propertyName}]`;
            newInput.value = variantData[metafieldKey];
            newInput.className = 'js-variant-property';            
            
            const variantIdInput = this.productForm.querySelector('input[name="id"]');
            if (variantIdInput && variantIdInput.nextSibling) {
              this.propertyContainer.insertBefore(newInput, variantIdInput.nextSibling);
            } else {
              this.propertyContainer.appendChild(newInput);
            }
          }
        } else {          
          if (existingInput) {
            existingInput.remove();
          }
        }
      });
    }
  }

  customElements.define('variant-properties', VariantProperties);
}
